import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboardAllRequests,
  fetchDashboardPendingRequests,
  fetchDashboardStatistics,
  fetchPendingApprovalMemberships,
} from "../actions/dashboardActions";

const initialState = {
  allRequests: [],
  pendingRequests: [],
  pendingApprovals: [],
  statistics: {
    members: [],
    payments: [],
    accessRequests: [],
  },
  isLoadingAll: false,
  isLoadingPending: false,
  isLoadingStatistics: false,
  isLoadingPendingApprovals: false,
  errorAll: null,
  errorPending: null,
  errorStatistics: null,
  errorPendingApprovals: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboardErrors(state) {
      state.errorAll = null;
      state.errorPending = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all requests
      .addCase(fetchDashboardAllRequests.pending, (state) => {
        state.isLoadingAll = true;
        state.errorAll = null;
      })
      .addCase(fetchDashboardAllRequests.fulfilled, (state, action) => {
        state.isLoadingAll = false;
        state.allRequests = Array.isArray(action.payload)
          ? action.payload.map((request) => ({
            ...request,
            requestType:
              request.requestType === "Executive Request"
                ? "Executive"
                : request.requestType,
          }))
          : [];
      })
      .addCase(fetchDashboardAllRequests.rejected, (state, action) => {
        state.isLoadingAll = false;
        state.allRequests = []; // Ensure empty array on error
        state.errorAll = action.payload;
      })
      // Fetch pending requests
      .addCase(fetchDashboardPendingRequests.pending, (state) => {
        state.isLoadingPending = true;
        state.errorPending = null;
      })
      .addCase(fetchDashboardPendingRequests.fulfilled, (state, action) => {
        state.isLoadingPending = false;
        state.pendingRequests = Array.isArray(action.payload)
          ? action.payload.map((request) => ({
            ...request,
            requestType:
              request.requestType === "Executive Request"
                ? "Executive"
                : request.requestType,
          }))
          : [];
      })
      .addCase(fetchDashboardPendingRequests.rejected, (state, action) => {
        state.isLoadingPending = false;
        state.pendingRequests = []; // Ensure empty array on error
        state.errorPending = action.payload;
      })
      // Fetch dashboard statistics
      .addCase(fetchDashboardStatistics.pending, (state) => {
        state.isLoadingStatistics = true;
        state.errorStatistics = null;
      })
      .addCase(fetchDashboardStatistics.fulfilled, (state, action) => {
        state.isLoadingStatistics = false;
        state.statistics = action.payload;
      })
      .addCase(fetchDashboardStatistics.rejected, (state, action) => {
        state.isLoadingStatistics = false;
        state.errorStatistics = action.payload;
      })
      // Fetch pending approval memberships
      .addCase(fetchPendingApprovalMemberships.pending, (state) => {
        state.isLoadingPendingApprovals = true;
        state.errorPendingApprovals = null;
      })
      .addCase(fetchPendingApprovalMemberships.fulfilled, (state, action) => {
        state.isLoadingPendingApprovals = false;
        state.pendingApprovals = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchPendingApprovalMemberships.rejected, (state, action) => {
        state.isLoadingPendingApprovals = false;
        state.pendingApprovals = [];
        state.errorPendingApprovals = action.payload;
      });
  },
});

export const { clearDashboardErrors } = dashboardSlice.actions;
export default dashboardSlice.reducer;
